import styled from 'styled-components';

export const StepWrap = styled('div')`

`